import React from 'react';
import CountryFlag from '../common/CountryFlag';

// Mapping of ISO 639-1 language codes to ISO 3166-1 alpha-2 country codes for cases
// where the language code does not match the expected country flag.
const localeToCountryOverrides = {
  'en': 'us',
  'pt': 'br',
  'ar': 'sa', // Arabic → Saudi Arabia
  'bn': 'bd', // Bengali → Bangladesh
  'cs': 'cz', // Czech → Czechia
  'da': 'dk', // Danish → Denmark
  'el': 'gr', // Greek → Greece
  'et': 'ee', // Estonian → Estonia
  'fa': 'ir', // Persian → Iran
  'he': 'il', // Hebrew → Israel
  'hi': 'in', // Hindi → India
  'hy': 'am', // Armenian → Armenia
  'ja': 'jp', // Japanese → Japan
  'ka': 'ge', // Georgian → Georgia
  'ko': 'kr', // Korean → South Korea
  'ms': 'my', // Malay → Malaysia
  'nb': 'no', // Norwegian Bokmål → Norway
  'nn': 'no', // Norwegian Nynorsk → Norway
  'sl': 'si', // Slovene → Slovenia
  'sq': 'al', // Albanian → Albania
  'sr': 'rs', // Serbian → Serbia
  'sv': 'se', // Swedish → Sweden
  'sw': 'tz', // Swahili → Tanzania
  'ta': 'in', // Tamil → India
  'uk': 'ua', // Ukrainian → Ukraine
  'ur': 'pk', // Urdu → Pakistan
  'vi': 'vn', // Vietnamese → Vietnam
  'zh': 'cn', // Chinese → China
};

export function LocaleFlag({ locale, ... props }) {
  return <CountryFlag round countryCode={localeToCountryOverrides[locale] || locale} {... props} />;
}
